/* eslint-disable */
/** Date: 10/2/2020*/

// import { valueOf } from "core-js/fn/_";

/* luminate donation form  */
export default {
    inserted: function(el) {
        const button = el.querySelector("[type=submit]");
        const amountRadios = el.querySelectorAll('input[name="amount_select"]');
        const otherAmount = el.querySelector('input[name="amount_other"]');
        const amount = el.querySelector('input[name="amount"]');
        const donationDiv = el.querySelector("#donation");
        const errorMessage = document.querySelector(".error-message");
        var spinner = document.createElement('span');
        spinner.classList.add('spinner-border','spinner-border-sm');
        spinner.setAttribute('role', 'status');
        spinner.setAttribute('aria-hidden', 'true');
        button.classList.add('has-spinner');
        

        // ON SUBMIT - APPEND FREQUENCY AND AMOUNT TO FORM ACTION 
        el.onsubmit = function(e){
            var frequencyValue = el.querySelector('input[name="frequency"]:checked').value;
            var amountValue = el.querySelector('input[name="amount"]').value;
            var action_src = el.action;
            action_src += "&amount=" + amountValue + "&frequency=" + frequencyValue; 
            el.action = action_src;
            button.append(spinner);
            button.disabled = true; // only submit one time
        };

        function unselectAllAmountRadios() {
            Array.prototype.slice.call(amountRadios).forEach(function(radio) {
                radio.checked = false;
            });
        }

        function clearAmountOther() {
            otherAmount.value = "";
        }

        function setAmountHidden(val) {
            //for backend to get value amount either from radio or input text field
            if (val != "undefined") {
                amount.value = val;
            }
        }

        donationDiv.addEventListener("input", function(e) {
            // listens for input change
            switch (e.target.name) {
                case "amount_other":
                    unselectAllAmountRadios();
                    break;
                case "amount_select":
                    clearAmountOther();
                    break;
            }
            validateDonation();
        });

        function validateDonation() {
            var selected = document.querySelector(
                'input[name="amount_select"]:checked'
            );
            var selectedValue = selected ? selected.value : "";

            if (selectedValue.length >= 2 && otherAmount.value.length === 0) {
                button.disabled = false;
                errorMessage.style.display = "none";
                setAmountHidden(selectedValue);
            } else if (otherAmount.value > 9 && otherAmount.value < 50001) {
                button.disabled = false;
                errorMessage.style.display = "none";
                setAmountHidden(otherAmount.value);
            } else {
                button.disabled = true;
                errorMessage.style.display = "block";
                setAmountHidden("");
            }
        }

        // Run on page load
        validateDonation();
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/luminate-donate-form.js